"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;
var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js").default;
var _inherits = require("/vercel/path0/node_modules/@babel/runtime/helpers/inherits.js").default;
var _createSuper = require("/vercel/path0/node_modules/@babel/runtime/helpers/createSuper.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SavingsSDK = void 0;
var ethers_1 = require("ethers");
var sdk_1 = require("../base/sdk");
var SavingsSDK = /*#__PURE__*/function (_sdk_1$BaseSDK) {
  _inherits(SavingsSDK, _sdk_1$BaseSDK);
  var _super = _createSuper(SavingsSDK);
  function SavingsSDK() {
    _classCallCheck(this, SavingsSDK);
    return _super.apply(this, arguments);
  }
  _createClass(SavingsSDK, [{
    key: "hasBalance",
    value: //simple helper for checking an active savings account
    function () {
      var _hasBalance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(account) {
        var contract, balance;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              contract = this.getContract("GoodDollarStaking");
              if (!(contract && account)) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return contract.balanceOf(account);
            case 4:
              balance = _context.sent;
              return _context.abrupt("return", !balance.isZero());
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function hasBalance(_x) {
        return _hasBalance.apply(this, arguments);
      }
      return hasBalance;
    }()
  }, {
    key: "onTokenTransfer",
    value: function () {
      var _onTokenTransfer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(amount) {
        var contract, stakeContract, callData, transfer;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              contract = this.getContract("GoodDollar");
              stakeContract = this.getContract("GoodDollarStaking");
              _context2.prev = 2;
              callData = ethers_1.ethers.constants.HashZero;
              transfer = contract.transferAndCall(stakeContract.address, amount, callData);
              return _context2.abrupt("return", transfer);
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](2);
              if (!(_context2.t0.code === 4001)) {
                _context2.next = 14;
                break;
              }
              throw new Error("User cancelled transaction confirmation");
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2, 8]]);
      }));
      function onTokenTransfer(_x2) {
        return _onTokenTransfer.apply(this, arguments);
      }
      return onTokenTransfer;
    }()
  }, {
    key: "withdraw",
    value: function () {
      var _withdraw = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(amount, isFullWithdraw) {
        var contract, shares, _withdraw2;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              contract = this.getContract("GoodDollarStaking");
              _context3.prev = 1;
              if (!isFullWithdraw) {
                _context3.next = 12;
                break;
              }
              _context3.t1 = contract;
              _context3.next = 6;
              return contract.signer.getAddress();
            case 6:
              _context3.t2 = _context3.sent;
              _context3.next = 9;
              return _context3.t1.sharesOf.call(_context3.t1, _context3.t2);
            case 9:
              _context3.t0 = _context3.sent;
              _context3.next = 15;
              break;
            case 12:
              _context3.next = 14;
              return contract.amountToShares(amount);
            case 14:
              _context3.t0 = _context3.sent;
            case 15:
              shares = _context3.t0;
              _withdraw2 = contract.withdrawStake(shares);
              return _context3.abrupt("return", _withdraw2);
            case 20:
              _context3.prev = 20;
              _context3.t3 = _context3["catch"](1);
              if (!(_context3.t3.code === 4001)) {
                _context3.next = 26;
                break;
              }
              throw new Error("User cancelled transaction confirmation");
            case 26:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 20]]);
      }));
      function withdraw(_x3, _x4) {
        return _withdraw.apply(this, arguments);
      }
      return withdraw;
    }()
  }, {
    key: "getStakerInfo",
    value: function () {
      var _getStakerInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(account) {
        var contract, req;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (account) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              contract = this.getContract("GoodDollarStaking");
              _context4.prev = 3;
              _context4.next = 6;
              return contract.stakersInfo(account).then(function (res) {
                return res;
              });
            case 6:
              req = _context4.sent;
              return _context4.abrupt("return", req);
            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](3);
              if (!(_context4.t0.code === 4001)) {
                _context4.next = 16;
                break;
              }
              throw new Error("User cancelled transaction confirmation");
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[3, 10]]);
      }));
      function getStakerInfo(_x5) {
        return _getStakerInfo.apply(this, arguments);
      }
      return getStakerInfo;
    }()
  }]);
  return SavingsSDK;
}(sdk_1.BaseSDK);
exports.SavingsSDK = SavingsSDK;